"use client";

import { Link } from "@/i18n/navigation";
import { Badge } from "@/components/ui/badge";
import { Banner } from "@/components/shared/banner";
import { CustomButton } from "@/components/ui/custom-button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { CustomForm } from "@/components/forms";
import { useState } from "react";
import { case_studies } from "../../../cms/case-studies";
import { ContentRenderer } from "@/features/content/components/ContentRenderer";
import { add_blocks_metadata } from "@/features/editor/utils/content-blocks";

import CollegeCard from "@/components/university-of-birmingham/university-of-birmingham/cards/college_card";

export const dynamicParams = false;

export default function UoBComponent() {
	const [isModalOpen, setIsModalOpen] = useState(false);

	return (
		<div className="top-[65px] flex w-full snap-y snap-mandatory flex-col overflow-x-clip">
			<Banner
				variant="article"
				title="The University of Birmingham"
				description="StudyStash partners with the University of Birmingham to evaluate the impact of AI on student experience"
				authorName="Joanna Williams"
				authorImage="/team/joanna_williams.jpeg"
				publishDate="Sep 1, 2024"
				readingTime="8 min read"
				articleImage="/uob_lecture.jpg"
				articleImageAlt="StudyStash co-founder presenting a lecture to students at the University of Birmingham"
				className="mb-10"
			/>

			<div className="flex min-h-fit w-full justify-center pt-10 px-6 sm:px-8 max-w-7xl mx-auto">
				<div className="flex flex-col gap-12 w-full">
					<div className="hidden lg:block shrink-0 mt-16">
						<div className="flex items-start gap-6">
							<div className="w-96">
								<Link
									href="https://www.birmingham.ac.uk/news/2024/student-entrepreneurs-score-business-success-with-university-wide-education-enhancement-project"
									target="_blank"
								>
									<img
										src="/uob_logo.png"
										alt="University of Birmingham Logo"
										className="w-full"
									/>
								</Link>
							</div>
							<div className="flex flex-col gap-2 -mt-1">
								<CustomButton
									variant="outline"
									size="sm"
									className="w-full"
									onClick={() => setIsModalOpen(true)}
								>
									Read the study
								</CustomButton>
								<Link href="/pilot-program" className="w-full">
									<CustomButton
										variant="primary"
										size="sm"
										className="w-full"
									>
										Join the pilot
									</CustomButton>
								</Link>
							</div>
						</div>
					</div>

					<div className="flex-1 min-w-0 lg:py-12 lg:pt-20">
						<div className="mb-12 grid grid-cols-1 gap-6 lg:grid-cols-2">
							<div>
								<div className="grid grid-cols-2 gap-4">
									<div>
										<h3 className="text-2xl font-semibold">5000+</h3>
										<p className="text-sm text-gray-500">Students Participating</p>
									</div>
									<div>
										<h3 className="text-2xl font-semibold">15+</h3>
										<p className="text-sm text-gray-500">Languages</p>
									</div>
									<div>
										<h3 className="text-2xl font-semibold">20+</h3>
										<p className="text-sm text-gray-500">Courses Participating</p>
									</div>
									<div>
										<h3 className="text-2xl font-semibold">5/5</h3>
										<p className="text-sm text-gray-500">Colleges Participating</p>
									</div>
								</div>
							</div>

							<div className="pt-12 lg:pt-0">
								<h2 className="mb-4 text-xs font-semibold sm:text-lg">Key Subjects</h2>
								<div className="flex max-w-[500px] flex-wrap gap-2">
									<Badge
										variant="secondary"
										className="w-max"
									>
										🩺 Medicine
									</Badge>
									<Badge
										variant="secondary"
										className="w-max"
									>
										📜 Arts and Law
									</Badge>
									<Badge
										variant="secondary"
										className="w-max"
									>
										🧬 Biomedical Sciences
									</Badge>
									<Badge
										variant="secondary"
										className="w-max"
									>
										🛠️ Engineering and Physical Sciences
									</Badge>
									<Badge
										variant="secondary"
										className="w-max"
									>
										🏃‍♂️ Sports Science
									</Badge>
									<Badge
										variant="secondary"
										className="w-max"
									>
										🌍 Politics
									</Badge>
									<Badge
										variant="secondary"
										className="w-max"
									>
										🌐 9 Modern Languages
									</Badge>
									<Badge
										variant="secondary"
										className="w-max"
									>
										🧬 Biochemistry
									</Badge>
									<Badge
										variant="secondary"
										className="w-max"
									>
										🩹 Nursing
									</Badge>
									<Badge
										variant="secondary"
										className="w-max"
									>
										🧪 Chemical Engineering
									</Badge>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="flex min-h-fit w-full justify-center pb-16 px-6 sm:px-8 max-w-7xl mx-auto">
				<div className="flex w-full">
					<div className="flex-1 min-w-0">
						<div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
							<CollegeCard slug={"aal"} />
							<CollegeCard slug={"eps"} />
							<CollegeCard slug={"les"} />
							<CollegeCard slug={"mah"} />
							<CollegeCard slug={"coss"} />
						</div>
					</div>
				</div>
			</div>

			{/* Press Release Blog */}
			<div className="max-w-7xl mx-auto px-6 sm:px-8 mb-16">
				<div className="prose max-w-none">
					<ContentRenderer
						blocks={add_blocks_metadata(case_studies["university-of-birmingham-press-release"].contentBlocks)}
					/>
				</div>
			</div>

			{/* Report Modal */}
			<Dialog open={isModalOpen} onOpenChange={setIsModalOpen}>
				<DialogContent className="sm:max-w-[600px] max-h-[95vh] overflow-y-auto">
					<div className="mt-6 flex w-full justify-center">
						<CustomForm formId="e1000-uob-evaluation-paper" />
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
}
